import { CAMPAIGN_DEMAND_SOURCES_LIST } from '../constants/campaign';

// Always returns a string. Campaigns created before the demand source feature
// have no campaignDemandSource, and a selector that yields undefined breaks
// react-data-table-component's comparator (undefined compares equal to every
// other value), which leaves the table unsorted.
export const getDemandSourceLabel = (value) =>
  CAMPAIGN_DEMAND_SOURCES_LIST.find((s) => s.value === value)?.label ?? value ?? '';
